import {none, Option, option, some} from "ts-option";
import User from "../../model/user/User";
import {store} from "../../navigation/ReduxProvider"
import UserLocation from "../../model/userLocation/UserLocation";

/**
 * Get installer portal user.
 * @param {string} userId installer portal user identifier.
 * @returns {Option<User>} Installer portal user.
 */
export function getUser(userId: string, state = store.getState()): Option<User> {
	let user = none;
	state.user.users.getOrElse([]).forEach(u => {
		if (u.id == userId) {
			user = some(u);
			return
		}
	});
	return user
}

/**
 * Get installer portal user.
 * @param {Option<string>} userId installer portal user identifier on none.
 * @returns {Option<User>} Installer portal user.
 */
export function getUserByOptionalId(userId: Option<string>): Option<User> {
	return userId.map(id => getUser(id)).getOrElse(none);
}

/**
 * Get installer portal user location
 * @param {string} userId installer portal user identifier.
 * @returns {Option<UserLocation>} Installer portal user location
 */
export function getUserLocation(userId: string): Option<UserLocation> {
	const userLocations = store.getState().userLocation.userLocations.getOrElse([]);
	return option(userLocations.filter((ul) => ul.userId == userId)[0]);
}

/**
 * Get installer portal logged user.
 * @returns {Option<User>} Installer portal user.
 */
export function getLoggedUser(): Option<User> {
	return store.getState().user.user;
}